<div class="modal-dialog">
  <div class="modal-content">
    

    <div class="modal-header">
        <h4 class="modal-title" id="myCenterModalLabel">{{'LABELS.PAYEX_PRIVATE_LIMITED' | translate}}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">X</button>
    </div>

    <div class="modal-body">
      <div class="icon-container">
        <ion-icon class="custom-icon" name="alert" [style.color]="'orange'"></ion-icon>
      </div>
      <div class="headerContent">{{options.header | translate}}</div>
      <span class="dialogContent">{{options.subttitle | translate}}</span>
      <form #mandateCancelForm="ngForm" (ngSubmit)="formSubmitted = true;">
        <div>
          <div class="row">
            <div class="col-12" >
              <div class="txtBorder">
                <input type="tel" class="selectOptionTxt" [(ngModel)]="options.payexPin" placeholder="User PIN"
                  name="pin" #pin="ngModel" required appNumberOnly maxlength="6" minlength="4"
                  style="-webkit-text-security:disc">
              </div>
              <ion-text color="danger">
                <p [hidden]="pin.valid || !formSubmitted">
                  {{ 'LABELS.ENTER_VALID_PIN' | translate}}
                </p>
              </ion-text>
            </div>
          </div>
          <div class="row">
            <div class="col-12"  *ngIf="options.header === CONFIRM_APPROVAL || options.header === CONFIRM_REJECTION">
              <div class="txtBorder">
                <input class="selectOptionTxt" [(ngModel)]="options.remarks" placeholder="{{'LABELS.PLEASE_ENTER_REMARK' | translate}}"
                  name="remarks" #remarks="ngModel">
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    
    <div class="modal-footer">
   
        <div class="row button-list">
          <div class="col-12" >
            <button type="button" class="btn fis-btn" (click)="close()"> {{ 'LABELS.BACK' | translate}}
            </button>
            <button type="button" class="btn fis-btn" (click)="onPinEntered()"
              [disabled]="loading || !mandateCancelForm.valid"> {{ 'LABELS.CONFIRM' | translate}}
            </button>
          </div>
        </div>
     
    </div>

  </div>
</div>
